import superagent from 'superagent'

const weatherUpdateAction = (payload) => ({
  type: 'WEATHER_UPDATE_ACTION',
  payload: payload
})

export const weatherActionRemove = () => ({
  type: 'WEATHER_ACTION_REMOVE',
})

export const weatherUpdate = (data) => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/Weather/GetSidebar?latitude=${data.lat}&longitude=${data.lng}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err.status)
          return
        }
        else {
          resolve(res.body)
          dispatch(weatherUpdateAction(res.body))
        }
      })
  })

}

export const weatherData = (data, callback) => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI__}/Weather/GetSidebar?latitude=${data.lat}&longitude=${data.lng}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          reject(err.status)
          return
        }
        else {
          resolve(res.body)
          callback(res.body)
        }
      })
  })

}
